import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from "@angular/common";

import { AppRoutingModule } from './app-routing.module';

import { GridModule } from '@progress/kendo-angular-grid';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { IconsModule } from '@progress/kendo-angular-icons';

import uk from "@angular/common/locales/uk";
import "@progress/kendo-angular-intl/locales/uk/all";
registerLocaleData(uk);

import { AppComponent } from './app.component';
import { LayoutCondensedComponent } from './layouts';

import { ContPatientAppoinmentCreateComponent } from './containers/patient-appointment/create';

import { PatientAppointmentCreateComponent } from './components/patient/appointment-create';
import { PatientDetailsComponent } from './components/patient/details';
import { PatientEditComponent } from './components/patient/edit';

import { MedicalAppointmentsListComponent } from './components/medical-appointment/list';
import { MedicalAppointmentQueuesListComponent } from './components/medical-appointment/queues-list';
import { MedicalAppointmentQueuesPeriodListComponent } from './components/medical-appointment/queues-period-list';
import { MedicalAppointmentQueuesPeriodList2Component } from './components/medical-appointment/queues-period-list2';

import { KendoDialogAlertComponent } from './shared/controls/kendo-dialog-alert';




@NgModule({
  declarations: [
    AppComponent, LayoutCondensedComponent, ContPatientAppoinmentCreateComponent,
    PatientAppointmentCreateComponent, PatientDetailsComponent, PatientEditComponent, 
    MedicalAppointmentsListComponent, MedicalAppointmentQueuesListComponent, 
    MedicalAppointmentQueuesPeriodListComponent, MedicalAppointmentQueuesPeriodList2Component, 
    KendoDialogAlertComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,

    GridModule,
    DateInputsModule,
    DialogsModule,
    ButtonsModule,

    AppRoutingModule,

    LabelModule,

    InputsModule,

    IconsModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "uk-UA" },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
